module.exports = __webpack_public_path__ + "img/ex-one-on.a6b92b1b.png";